import Cookies from 'js-cookie';
import { escapeHtml } from '../core/utilities.js';

var _ymmLookupCache = {
    makes: {},
    models: {}
};
var _ymmLookupRequests = {
    makes: {},
    models: {}
};
var _ymmResetCaptureAttached = false;

export function resetApplicationFacets() {
    Cookies.remove('pace-fitment-application');
}

export function _renderYmmSelectOptions(items, selectedValue, includeBlank) {
    var output = includeBlank;
    var selected = '';

    if (typeof items === 'undefined' || items === null) {
        return output;
    }

    if (items.popular) {
        output += '<optgroup label="Popular">';
        for (var i = 0; i < items.popular.length; i++) {
            selected = selectedValue == items.popular[i].id ? ' selected="selected"' : '';
            output +=
                '<option value="' +
                escapeHtml(items.popular[i].id) +
                '"' +
                selected +
                '>' +
                escapeHtml(items.popular[i].value) +
                '</option>';
        }
        output += '</optgroup>';
    }

    if (items.all) {
        output += items.popular ? '<optgroup label="All">' : '';
        for (var j = 0; j < items.all.length; j++) {
            selected = selectedValue == items.all[j].id ? ' selected="selected"' : '';
            output +=
                '<option value="' +
                escapeHtml(items.all[j].id) +
                '"' +
                selected +
                '>' +
                escapeHtml(items.all[j].value) +
                '</option>';
        }
        output += items.popular ? '</optgroup>' : '';
    }

    return output;
}

export function loadMakes(yearDropdown) {
    var $form = yearDropdown.closest('form');
    var setMake = $form.find('[data-set-make]').attr('data-set-make');
    var $makeDropdown = $form.find('.ymm-dropdown-make');
    var selectedMake =
        typeof setMake !== typeof undefined && setMake !== false
            ? setMake
            : $makeDropdown.val();
    var year = yearDropdown.val();
    var cacheKey = String(year);

    if (typeof year !== typeof undefined && year !== null && year != '') {
        if (typeof _ymmLookupRequests.makes[cacheKey] !== typeof undefined && _ymmLookupRequests.makes[cacheKey] && _ymmLookupRequests.makes[cacheKey].readyState !== 4) {
            $makeDropdown.attr('disabled', 'disabled');
            _ymmLookupRequests.makes[cacheKey].done(function (makes) {
                $makeDropdown.html(
                    _renderYmmSelectOptions(makes, selectedMake, '<option value="">Make</option>')
                ).removeAttr('disabled');
                loadModels($makeDropdown);
            });
            return;
        }

        if (typeof _ymmLookupCache.makes[cacheKey] !== typeof undefined && _ymmLookupCache.makes[cacheKey] !== null) {
            $makeDropdown.html(
                _renderYmmSelectOptions(_ymmLookupCache.makes[cacheKey], selectedMake, '<option value="">Make</option>')
            ).removeAttr('disabled');
            loadModels($makeDropdown);
            return;
        }

        var makesRequest = $.ajax({
            url: 'ymm/get_makes/' + year + '/1',
            dataType: 'json',
            beforeSend: function () {
                $makeDropdown.attr('disabled', 'disabled');
            },
            success: function (makes) {
                _ymmLookupCache.makes[cacheKey] = makes;
                $makeDropdown.html(
                    _renderYmmSelectOptions(makes, selectedMake, '<option value="">Make</option>')
                ).removeAttr('disabled');
                loadModels($makeDropdown);
            },
            complete: function () {
                _ymmLookupRequests.makes[cacheKey] = null;
            },
            error: function (jqXHR, textStatus) {
                if (textStatus !== 'abort') {
                    console.error(
                        'An error occurred while retrieving vehicle makes.'
                    );
                }
            },
        });

        _ymmLookupRequests.makes[cacheKey] = makesRequest;
    }
}

export function loadModels(makeDropdown) {
    var $form = makeDropdown.closest('form');
    var $yearDropdown = $form.find('.ymm-dropdown-year');
    var $modelDropdown = $form.find('.ymm-dropdown-model');
    var setModel = $form.find('[data-set-model]').attr('data-set-model');
    var selectedModel =
        typeof setModel !== typeof undefined && setModel !== null
            ? setModel
            : $modelDropdown.val();
    var year = $yearDropdown.val();
    var make = makeDropdown.val();
    var cacheKey = year + '_' + make;

    if (
        typeof year !== typeof undefined &&
        year !== null &&
        typeof make !== typeof undefined &&
        make !== null &&
        make != ''
    ) {
        if (typeof _ymmLookupRequests.models[cacheKey] !== typeof undefined && _ymmLookupRequests.models[cacheKey] && _ymmLookupRequests.models[cacheKey].readyState !== 4) {
            $modelDropdown.attr('disabled', 'disabled');
            _ymmLookupRequests.models[cacheKey].done(function (models) {
                $modelDropdown.html(
                    _renderYmmSelectOptions(models, selectedModel, '<option value="">Model</option>')
                ).removeAttr('disabled');
            });
            return;
        }

        if (typeof _ymmLookupCache.models[cacheKey] !== typeof undefined && _ymmLookupCache.models[cacheKey] !== null) {
            $modelDropdown.html(
                _renderYmmSelectOptions(_ymmLookupCache.models[cacheKey], selectedModel, '<option value="">Model</option>')
            ).removeAttr('disabled');
            return;
        }

        var modelsRequest = $.ajax({
            url: 'ymm/get_models/' + year + '/' + make + '/1',
            dataType: 'json',
            beforeSend: function () {
                $modelDropdown.attr('disabled', 'disabled');
            },
            success: function (models) {
                _ymmLookupCache.models[cacheKey] = models;
                $modelDropdown.html(
                    _renderYmmSelectOptions(_ymmLookupCache.models[cacheKey], selectedModel, '<option value="">Model</option>')
                ).removeAttr('disabled');
            },
            complete: function () {
                _ymmLookupRequests.models[cacheKey] = null;
            },
            error: function (jqXHR, textStatus) {
                if (textStatus !== 'abort') {
                    console.error(
                        'An error occurred while retrieving vehicle models.'
                    );
                }
            },
        });

        _ymmLookupRequests.models[cacheKey] = modelsRequest;
    }
}

export function setMakeModelNames(element) {
    var $form = element.closest('form');
    var $makeName = $form.find('[name="vehicle[MakeName]"]');
    var $modelName = $form.find('[name="vehicle[ModelName]"]');
    var $makeDropdown = $form.find('.ymm-dropdown-make');
    var $modelDropdown = $form.find('.ymm-dropdown-model');
    var make = $makeDropdown.val();
    var model = $modelDropdown.val();

    // Emptiness, not null. These are <select>s carrying a blank first option, so .val()
    // answers '' when nothing is chosen - null only when the element has no options at all.
    // The old `make !== null` was therefore true for a blank Make, which made the else
    // unreachable: the previous Make's models stayed in the dropdown, the hidden MakeName
    // kept the previous label, and the submit button stayed enabled with no vehicle chosen.
    // ymm_models() already treats empty($makeid) as "no make", and loadModels() below
    // guards on make != '', so falsy-means-absent is what the rest of the flow assumes.
    if (make) {
        $makeName.val($makeDropdown.find('option:selected').text());
    } else {
        $makeName.val('');
        $modelDropdown.html('<option value="">Model</option>');
    }

    if (model) {
        $modelName.val($modelDropdown.find('option:selected').text());
    } else {
        $modelName.val('');
    }

    if (make && model) {
        $form.find('button[type="submit"]').removeAttr('disabled');
    } else {
        $form.find('button[type="submit"]').attr('disabled', 'disabled');
    }
}

// The nav/home/modal selects are rendered server-side for the vehicle already in session
// (ymm_makes()/ymm_models() in catalog_helper.php), so the make and model options are
// already present and correct on first paint. Firing loadMakes() here would spend two
// serialized round trips - get_models cannot start until get_makes returns the make -
// rebuilding markup that is identical. Verify rather than assume: if either expected
// option is missing, fall through to the AJAX path exactly as before.
function ymmSelectsArePrefilled($ymmForm) {
    var setMake = $ymmForm.find('[data-set-make]').attr('data-set-make');
    var setModel = $ymmForm.find('[data-set-model]').attr('data-set-model');

    if (!setMake || !setModel) {
        return false;
    }

    return (
        $ymmForm.find('.ymm-dropdown-make option[value="' + setMake + '"]').length > 0 &&
        $ymmForm.find('.ymm-dropdown-model option[value="' + setModel + '"]').length > 0
    );
}

export function initYMM() {
    var $ymmForms = $('.ymm-form');

    $ymmForms.each(function () {
        var $ymmForm = $(this);
        var setYear = $ymmForm.find('[data-set-year]').attr('data-set-year');
        var setVIN = $ymmForm.find('[data-set-vin]').attr('data-set-vin');

        if (
            typeof setYear !== typeof undefined &&
            setYear !== false &&
            setYear !== null &&
            setYear !== ''
        ) {
            $ymmForm
                .find('.ymm-dropdown-year option[value=' + setYear + ']')
                .attr('selected', 'selected');

            if (!ymmSelectsArePrefilled($ymmForm)) {
                loadMakes($ymmForm.find('.ymm-dropdown-year'));
            }
        }

        if (
            typeof setVIN !== typeof undefined &&
            setVIN !== false &&
            setVIN !== null &&
            setVIN !== ''
        ) {
            $ymmForm.find('.ymm-vin').val(setVIN);
        }
    });

    $ymmForms.on('change', '.ymm-dropdown-year', function () {
        var $ymmForm = $(this).closest('form');

        resetApplicationFacets();

        if ($(this).val() == '') {
            $ymmForm.find('.ymm-dropdown-make').html('<option value="">Make</option>');
            $ymmForm.find('.ymm-dropdown-model').html('<option value="">Model</option>');
        } else {
            loadMakes($(this));
            setMakeModelNames($(this));
        }
    });

    $ymmForms.on('change', '.ymm-dropdown-make', function () {
        var $ymmForm = $(this).closest('form');

        resetApplicationFacets();
        loadModels($(this));
        setMakeModelNames($(this));

        if ($ymmForm.hasClass('ymm-nav-form')) {
            $(this)
                .closest('form')
                .find('.ymm-dropdown-model')
                .val('')
                .trigger('change');
        }
    });

    $ymmForms.on('change', '.ymm-dropdown-model', function () {
        var $ymmForm = $(this).closest('form');
        resetApplicationFacets();
        setMakeModelNames($(this));

        if ($ymmForm.hasClass('ymm-nav-form') && $(this).val()) {
            $ymmForm.trigger('submit');
        }
    });

    $ymmForms.on('change', '.ymm-dropdown-recent-search', function () {
        var $ymmForm = $(this).closest('form');
        var $yearDropdown = $ymmForm.find('.ymm-dropdown-year');
        var $makeDropdown = $ymmForm.find('.ymm-dropdown-make');
        var $modelDropdown = $ymmForm.find('.ymm-dropdown-model');
        var $vinInput = $ymmForm.find('.ymm-vin');
        var $submitButton = $ymmForm.find('[type="submit"]');

        if ($(this).val().length > 0) {
            resetApplicationFacets();
            $yearDropdown.val('').addClass('disabled').prop('disabled', true);
            $makeDropdown.val('').addClass('disabled').prop('disabled', true);
            $modelDropdown.val('').addClass('disabled').prop('disabled', true);
            $vinInput.val('').addClass('disabled').prop('disabled', true);
            $submitButton.prop('disabled', false);
        } else {
            $yearDropdown.removeClass('disabled').prop('disabled', false);
            $makeDropdown
                .removeClass('disabled')
                .prop('disabled', false)
                .html('<option value="">Make</option>');
            $modelDropdown
                .removeClass('disabled')
                .prop('disabled', false)
                .html('<option value="">Model</option>');
            $submitButton.prop('disabled', true);
            $vinInput.removeClass('disabled').prop('disabled', false).val('');
        }
    });
    
    $ymmForms.on('keyup', '.ymm-vin', function () {
        var $ymmForm = $(this).closest('form');
        var $yearDropdown = $ymmForm.find('.ymm-dropdown-year');
        var $makeDropdown = $ymmForm.find('.ymm-dropdown-make');
        var $modelDropdown = $ymmForm.find('.ymm-dropdown-model');
        var $submitButton = $(this).closest('form').find('[type="submit"]');

        if ($(this).val().length > 0) {
            resetApplicationFacets();
            $yearDropdown.val('').addClass('disabled').prop('disabled', true);
            $makeDropdown.val('').addClass('disabled').prop('disabled', true);
            $modelDropdown.val('').addClass('disabled').prop('disabled', true);
            $submitButton.prop('disabled', false);
        } else {
            $yearDropdown.removeClass('disabled').prop('disabled', false);
            $makeDropdown
                .removeClass('disabled')
                .prop('disabled', false)
                .html('<option value="">Make</option>');
            $modelDropdown
                .removeClass('disabled')
                .prop('disabled', false)
                .html('<option value="">Model</option>');
            $submitButton.prop('disabled', true);
        }
    });

    // Capture phase: runs before Bootstrap's dropdown toggle on the parent <a>, so clear wins over open.
    if (!_ymmResetCaptureAttached) {
        _ymmResetCaptureAttached = true;
        document.addEventListener(
            'click',
            function ymmNavResetCapture(e) {
                var el = e.target.closest('[data-reset-ymm]');
                if (!el) {
                    return;
                }
                var url = el.getAttribute('data-reset-ymm');
                if (!url || url.length <= 1) {
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                resetApplicationFacets();
                window.location.href = url;
            },
            true
        );
    }

    $(document).on('click', '.reset-ymm', function (e) {
        e.preventDefault();
        resetApplicationFacets();
        window.location.href = $(this).attr('href');
    });
}
